// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.place {
  padding-top: 3rem;
}
.place img {
  border-radius: 10px;
}
.place mat-progress-bar {
  max-width: 420px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBsYWNlLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksaUJBQUE7QUFDSjtBQUFJO0VBQ0ksbUJBQUE7QUFFUjtBQUFJO0VBQ0ksZ0JBQUE7QUFFUiIsImZpbGUiOiJwbGFjZS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5wbGFjZSB7XG4gICAgcGFkZGluZy10b3A6IDNyZW07XG4gICAgaW1nIHtcbiAgICAgICAgYm9yZGVyLXJhZGl1czogMTBweDtcbiAgICB9XG4gICAgbWF0LXByb2dyZXNzLWJhciB7XG4gICAgICAgIG1heC13aWR0aDogNDIwcHg7XG4gICAgfVxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/auth/place/place.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAAI;EACI,mBAAA;AAER;AAAI;EACI,gBAAA;AAER;AACA,4eAA4e","sourcesContent":[".place {\n    padding-top: 3rem;\n    img {\n        border-radius: 10px;\n    }\n    mat-progress-bar {\n        max-width: 420px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
